"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stockpile_types_1 = require("./stockpile.types");
const toolkit_1 = require("@reduxjs/toolkit");
const app_types_1 = require("pages/app.types");
const initialState = {
    onReset: false,
    isLoading: true,
    isPushLED: true,
    isError: false,
    onCallWebSocket: true,
    isSuccess: false,
    isLoadingDetail: true,
    isLoadingSubmit: false,
    errorCode: 0,
    errorMessage: '',
    isToast: false,
    messageToast: '',
    dataGrid: [],
    dataStockpileConfig: [],
    mutationMode: false,
    dataGridHistory: [],
    listDumpTruck: [],
    dataArea: [],
    dataBrand: [],
    dataExcavator: [],
    dataSeam: [],
    dataItem: {
        id: '0',
        stockpile_code: '',
        stockpile_name: '',
        is_active: {
            value: true,
            status: 'Active',
        },
        modified_by: '',
        modified_date: new Date(),
        created_by: '',
        created_date: new Date(),
        description: '',
        dt_no: '',
        penalty: '',
    },
    dataItemHistory: {
        id: '',
        shift: 0,
        pit_id: '',
        pos_id: '',
        area_id: '',
        seam_id: '',
        rfid_tag: '',
        brand_id: '',
        pit_name: '',
        penalty: '0',
        area_name: '',
        seam_name: '',
        total_trip: 0,
        ticket_no: '',
        penalty_id: 0,
        brand_name: '',
        created_by: '',
        nett_volume: 0,
        brand_color: '',
        modified_by: '',
        dumptruck_id: '',
        dumptruck_no: '',
        excavator_id: '',
        excavator_no: '',
        is_active: false,
        contractor_id: '',
        capacity_volume: 0,
        contractor_name: '',
        gate_in: new Date(),
        gate_out: new Date(),
        created_date: new Date(),
        modified_date: new Date(),
        image_penalty_evidence: '',
        main_entrance_in: new Date(),
    },
    dataStatesHistory: {
        filterable: false,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }],
    },
    dataStates: {
        filterable: false,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }],
        filter: {
            logic: 'and',
            filters: [{ field: 'type', operator: 'contains', value: 'stockpile' }],
        },
    },
    dataHistory: [],
    dataDumptruck: {
        id: '',
        dumptruck_id: '',
        dumptruck_no: '',
        gate_in: new Date(),
        gate_out: new Date(),
        main_entrance_in: new Date(),
        capacity_volume: 0,
        rfid_tag: '',
        contractor_id: '',
        contractor_name: '',
        excavator_id: '',
        excavator_no: '',
        brand_id: '',
        brand_name: '',
        brand_color: '',
        pit_id: '',
        pit_name: '',
        area_id: '',
        area_name: '',
        seam_id: '',
        seam_name: '',
        pos_id: '',
        penalty_id: 0,
        penalty: '',
        total_trip: 0,
        shift: 0,
        image_penalty_evidence: '',
        is_active: false,
        nett_volume: 0,
        ticket_no: '',
        created_date: new Date(),
        created_by: '',
        modified_date: new Date(),
        modified_by: '',
    },
    status: 'Offline',
    pos_name: 'POS - 1',
    hex_tag: ''
};
const stockpileReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [stockpile_types_1.stockpileTypes.RESET]: (state, action) => {
        const { onReset } = action.payload;
        return Object.assign(Object.assign({}, state), { onReset: onReset });
    },
    [stockpile_types_1.stockpileTypes.SET_SUBMIT_LOADING]: (state, action) => {
        const { isLoadingSubmit } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoadingSubmit });
    },
    [stockpile_types_1.stockpileTypes.SET_DATA_GRID_HISTORY]: (state, action) => {
        const { dataHistory, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataHistory, isLoading: false, dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { total: count }) });
    },
    [stockpile_types_1.stockpileTypes.ON_PAGE_CHANGE_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStatesHistory: action.payload.dataStatesHistory });
    },
    [stockpile_types_1.stockpileTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStatesHistory, dataGrid } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStatesHistory,
            dataGrid, isLoading: false });
    },
    [stockpile_types_1.stockpileTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess, penalty, onCallWebSocket, isPenalty, dataItemHistory, dataDumptruck } = action.payload;
        return Object.assign(Object.assign({}, state), { penalty,
            isPenalty,
            onCallWebSocket, mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess, dataItemHistory: dataItemHistory ? dataItemHistory : initialState.dataItemHistory, dataDumptruck: dataDumptruck ? dataDumptruck : initialState.dataDumptruck });
    },
    [stockpile_types_1.stockpileTypes.ON_DELETE]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.filter((item) => item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id)) });
    },
    [stockpile_types_1.stockpileTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { filter: action.payload }) });
    },
    [stockpile_types_1.stockpileTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { sort: action.payload }) });
    },
    [stockpile_types_1.stockpileTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isLoading: false, isLoadingSubmit: false, dataDumptruck: initialState.dataDumptruck });
    },
    [stockpile_types_1.stockpileTypes.SET_DATA_CONFIGURATION_STOCKPILE]: (state, action) => {
        const { dataStockpileConfig, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStockpileConfig, isLoading: false, isPushLED: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [stockpile_types_1.stockpileTypes.ON_PUSH_LED]: (state) => {
        return Object.assign(Object.assign({}, state), { isPushLED: false, isLoadingSubmit: false });
    },
    [stockpile_types_1.stockpileTypes.SET_DATA_DUMPTRUCK]: (state, action) => {
        const { dataDumptruck, hex_tag } = action.payload;
        return Object.assign(Object.assign({}, state), { dataDumptruck, hex_tag, onCallWebSocket: false });
    },
    [stockpile_types_1.stockpileTypes.GET_DETAIL]: (state, action) => {
        const { listDumpTruck } = action.payload;
        return Object.assign(Object.assign({}, state), { listDumpTruck });
    },
    [stockpile_types_1.stockpileTypes.GET_DROPDOWN]: (state, action) => {
        const { dataArea, dataBrand, dataExcavator, dataSeam } = action.payload;
        return Object.assign(Object.assign({}, state), { dataArea,
            dataSeam,
            dataBrand,
            dataExcavator, isLoadingDetail: false });
    },
    [stockpile_types_1.stockpileTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { isError } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoadingSubmit: false, isSuccess: !isError, mutationMode: false, isLoading: true, dataItem: initialState.dataItem, onCallWebSocket: false });
    },
    [stockpile_types_1.stockpileTypes.SET_STATUS]: (state, action) => {
        const { status } = action.payload;
        return Object.assign(Object.assign({}, state), { status });
    },
    [stockpile_types_1.stockpileTypes.SET_HEX]: (state, action) => {
        const { hex_tag } = action.payload;
        return Object.assign(Object.assign({}, state), { hex_tag });
    },
    [stockpile_types_1.stockpileTypes.SET_POS]: (state, action) => {
        const { pos_name } = action.payload;
        return Object.assign(Object.assign({}, state), { pos_name });
    },
    [stockpile_types_1.stockpileTypes.DT_NOT_FOUND]: (state, action) => {
        const { onCallWebSocket } = action.payload;
        return Object.assign(Object.assign({}, state), { onCallWebSocket });
    },
    [stockpile_types_1.stockpileTypes.SHOW_TOAST]: (state, action) => {
        const { isToast, messageToast } = action.payload;
        return Object.assign(Object.assign({}, state), { isToast,
            messageToast });
    }
});
exports.default = stockpileReducer;
